<template>
  <b-modal
    ref="aprovarContratoManualModal"
    size="xl"
    hide-footer
    no-close-on-backdrop
    :dialog-class="'alteracao-tamanho-pre-geracao'"
    :modal-class="'center-modal'"
    title="Aprovar Contrato Manualmente"
    title-class="titulo-modal"
    @show="showAprovarContratoManual"
    @hide="Close"
  >
    <div>
      <b-alert
        show
        variant="warning"
        class="p-1"
      >
        <strong>Atenção!</strong> Ao aprovar um contrato manualmente, esteja ciente que as informações de de pre-geração de contrato não serão preenchidas automaticamente.
      </b-alert>
      <!-- Botão de upload de PDF -->
      <div class="d-flex flex-row  align-items-center justify-items-center mb-3">
        <div>
          <input
            id="pdf-upload"
            type="file"
            accept="application/pdf"
            style="display: none;"
            :disabled="aprovarSemUpload"
            @change="onFileChange"
          >
          <label
            for="pdf-upload"
            class="btn btn-primary my-0 mr-1"
            :class="{ disabled: aprovarSemUpload }"
          >
            Selecionar PDF
          </label>
        </div>
        <b-button
          v-if="selectedFile"
          variant="danger"
          @click="removerPDF"
        >
          <feather-icon
            icon="TrashIcon"
            @click="removerPDF"
          />
        </b-button>
      </div>
      <!-- Área de preview do PDF -->
      <div
        v-if="pdfUrl"
        style="border: 1px solid #ccc;
        height: 600px;"
      >
        <iframe
          :src="pdfUrl"
          width="100%"
          height="100%"
          style="border: none;"
        />
      </div>
      <div v-else>
        <p>Nenhum PDF selecionado.</p>
      </div>

      <div class="form-check my-3">
        <b-form-checkbox
          id="aprovarSemUpload"
          v-model="aprovarSemUpload"
          class="form-check-input"
          :disabled="selectedFile"
        >
          <label
            class="form-check-label"
            for="aprovarSemUpload"
          >
            Aprovar contrato manualmente <strong>sem fazer upload de arquivo</strong>
          </label>
        </b-form-checkbox>
      </div>
      <!-- Botão para fazer upload (usando BootstrapVue) -->
      <b-button
        variant="success"
        class="my-3 ml-2"
        :disabled="(!selectedFile && !aprovarSemUpload)"
        @click="uploadFile"
      >
        Marcar contrato como aprovado
      </b-button>

    </div>
  </b-modal>
</template>
<script>
import { BModal } from 'bootstrap-vue'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import api from '@/app-modulo/comercial/cadastro-proposta/shared/services/api'

export default {
  name: 'AprovarContratoManual',
  components: {
    BModal,
  },
  props: {
    proposta: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedFile: null,
      pdfUrl: null,
      aprovarSemUpload: false,
    }
  },
  methods: {
    showAprovarContratoManual() {
      // Logic to execute when the modal is shown
      this.$refs.aprovarContratoManualModal.show()
    },
    Close() {
      // Logic to execute when the modal is shown
      this.$refs.aprovarContratoManualModal.hide()
    },
    onFileChange(event) {
      const file = event.target.files[0]
      if (file && file.type === 'application/pdf') {
        this.selectedFile = file
        // Revoga o Blob URL anterior, se existir
        if (this.pdfUrl) {
          URL.revokeObjectURL(this.pdfUrl)
        }
        this.pdfUrl = URL.createObjectURL(file)
      } else {
        this.selectedFile = null
        if (this.pdfUrl) {
          URL.revokeObjectURL(this.pdfUrl)
        }
        this.pdfUrl = null
        this.$swal({
          title: 'Arquivo inválido',
          text: 'Por favor, selecione um arquivo PDF válido.',
          icon: 'warning',
          confirmButtonText: 'OK',
        })
      }
    },
    uploadFile() {
      if (this.aprovarSemUpload) {
        this.$swal({
          title: 'aprovar contrato manualmente sem upload de PDF',
          text: 'Ao aprovar um contrato manualmente sem fazer upload de um arquivo PDF, a função de baixar contrato não funcionará corretamente. Alem disso, as informações de pre-geração não serão preenchidas automaticamente. Você tem certeza que deseja continuar?',
          confirmButtonText: 'Sim, desejo continuar',
          cancelButtonText: 'Cancelar',
          showCancelButton: true,
          focusConfirm: false,
          icon: 'warning',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-danger ml-1',
          },
        }).then(result => {
          if (result.isConfirmed) {
            api.aprovarContratoPropostaManualmenteSemUpload(this.proposta.id)
              .then(() => {
                this.$swal({
                  title: 'Sucesso',
                  text: 'Contrato aprovado com sucesso!',
                  icon: 'success',
                  confirmButtonText: 'OK',
                })
                this.Close()
              })
              .catch(() => {
                this.$swal({
                  title: 'Erro',
                  text: 'Ocorreu um erro ao aprovar o contrato. Por favor, tente novamente.',
                  icon: 'error',
                  confirmButtonText: 'OK',
                })
              })
          }
        })
      } else {
        api.aprovarContratoPropostaManualmente(this.proposta.id, this.selectedFile)
          .then(() => {
            this.$swal({
              title: 'Sucesso',
              text: 'Contrato aprovado com sucesso!',
              icon: 'success',
              confirmButtonText: 'OK',
            })
            this.Close()
          })
          .catch(() => {
            this.$swal({
              title: 'Erro',
              text: 'Ocorreu um erro ao aprovar o contrato. Por favor, tente novamente.',
              icon: 'error',
              confirmButtonText: 'OK',
            })
          })
      }
    },
    removerPDF() {
      this.selectedFile = null
      if (this.pdfUrl) {
        URL.revokeObjectURL(this.pdfUrl)
      }
      this.pdfUrl = null
    },
  },
}
</script>
